export const scrollToAddressSection = (e: React.MouseEvent<HTMLElement>): void => {
    if (!(e.currentTarget as HTMLElement).classList.contains("disabled-container")) return;

    const findElementByXPath = (xpath: string): HTMLElement | null =>
        document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null)
            .singleNodeValue as HTMLElement | null;

    const targetElement =
        findElementByXPath("//span[contains(text(), 'Shipping Address')]") ??
        findElementByXPath("//h2[contains(text(), 'Billing Address')]");

    if (!targetElement) return;

    scrollToElementWithCheckoutOffset(targetElement);
};

const getDefaultCheckoutScrollOffset = () => (window.innerWidth > 1088 ? 167 : window.innerWidth > 990 ? 113 : 98);

const getCheckoutScrollOffset = () => {
    const defaultOffset = getDefaultCheckoutScrollOffset();
    const possibleTopBars = Array.from(
        document.querySelectorAll<HTMLElement>(
            "header, nav, [class*='header'], [class*='Header'], [class*='sticky'], [class*='Sticky'], [id*='header'], [id*='Header']",
        ),
    );

    let maxBottom = 0;

    for (const element of possibleTopBars) {
        const styles = window.getComputedStyle(element);
        if (styles.display === "none" || styles.visibility === "hidden") {
            continue;
        }

        if (styles.position !== "fixed" && styles.position !== "sticky") {
            continue;
        }

        const rect = element.getBoundingClientRect();
        if (rect.height <= 0) {
            continue;
        }

        // Account for top bars that occupy or sit near the top viewport area.
        if (rect.top <= defaultOffset && rect.bottom > 0) {
            maxBottom = Math.max(maxBottom, rect.bottom);
        }
    }

    if (maxBottom > 0) {
        // Keep baseline breakpoint offset and only increase when needed.
        return Math.max(defaultOffset, Math.ceil(maxBottom) + 20);
    }

    return defaultOffset;
};

const scrollToElementWithCheckoutOffset = (targetElement: HTMLElement) => {
    const alignToTarget = (behavior: ScrollBehavior) => {
        const desiredTop = getCheckoutScrollOffset() + 16;
        const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        const targetScrollTop = Math.max(0, elementPosition - desiredTop);

        window.scrollTo({
            top: targetScrollTop,
            behavior,
        });
    };

    alignToTarget("smooth");

    // Re-align after potential async layout changes (state updates, sticky header transitions).
    window.setTimeout(() => {
        const desiredTop = getCheckoutScrollOffset() + 16;
        const currentTop = targetElement.getBoundingClientRect().top;

        if (Math.abs(currentTop - desiredTop) > 4) {
            alignToTarget("auto");
        }
    }, 180);
};

export const scrollToCheckoutSection = (selectors: string | string[]) => {
    const selectorList = Array.isArray(selectors) ? selectors : [selectors];

    for (const selector of selectorList) {
        const targetElement = document.querySelector(selector) as HTMLElement | null;
        if (!targetElement) {
            continue;
        }

        scrollToElementWithCheckoutOffset(targetElement);

        return;
    }
};